import { connect } from 'react-redux'
import { setTradeIn } from '../../actions'
import Interior from './Paint'

const mapStateToProps = state => ({
  tradeIn: state.tradeIn
})

const mapDispatchToProps = {
  setTradeIn
}

export default connect(mapStateToProps, mapDispatchToProps)(Interior)
